import React, { memo, useCallback, useState } from "react";

const setCookie = (name, value) =>
  (document.cookie = `${name}=${value}; path=/`);

const HelpLoginText = ({}) => {
  const [show, setShow] = useState(true);

  const handleClick = useCallback(() => {
    setShow((status) => !status);
  }, [setShow]);

  const handleSignIn = useCallback(() => {
    setCookie(
      "ECommRedirectURL",
      encodeURIComponent(`${window.location.origin}/help/home`)
    );
    window.location.href = "/account/sign-in.html";
  }, [setShow]);

  return (
    show && (
      <div className="help-login-wrapper">
        <div className="my-auto text-wrapper">
          <p className="font-weight-600 mb-0">Log in to get help with your orders, account and more.</p>
        </div>
        <div className="btn-wrapper">
          <button onClick={handleSignIn}>Sign in or create account</button>
        </div>
        <button className="close" aria-label="Close" onClick={handleClick}>
          X
        </button>
      </div>
    )
  );
};

export default memo(HelpLoginText);
